import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from "@/views/layout/index.vue"
import Login from "@/views/login/index.vue"
import Myorder from "@/views/myorder/index.vue"
import Pay from "@/views/pay/index.vue"
import Prodetail from "@/views/prodetail/index.vue"
import Search from "@/views/search/index.vue"
import Home from "@/views/layout/Home.vue"
import Category from "@/views/layout/Cartgory.vue"
import Cart from "@/views/layout/Cart.vue"
import User from "@/views/layout/User.vue"
import SearchList from "@/views/search/searchList.vue"
import store from '@/store'

Vue.use(VueRouter)



const router = new VueRouter({
  routes: [
    {
      // 首页
      path: '/',
      component: Layout,
      redirect: "/home",
      children: [
        {
          path: '/home',
          component: Home
        },
        {
          path: '/category',
          component: Category
        },
        {
          path: '/cart',
          component: Cart
        },
        {
          path: '/user',
          component: User
        }
      ]
    },
    {
      // 登录页
      path: "/login",
      component: Login
    },
    {
      // 订单页
      path: "/myorder",
      component: Myorder
    },
    {
      // 支付页
      path: "/pay",
      component: Pay
    },
    {
      //商品详情页面
      path: '/prodetail/:id?',
      component: Prodetail
    },
    {
      path: '/search',
      component: Search
    },
    {
      path:"/searchList",
      component:SearchList
    }


  ]
})

const token = store.state.user.userInfo
const authUlrs = ['/pay', '/myorder']
router.beforeEach((to, from, next) => {


  if (!authUlrs.includes(to.path)) {
    next()
    return
  }

  if (token) {
    next()
  } else {
    next('/login')
  }

})

export default router
